/** Formats an ISO 8601 timestamp from the API as a date in the user's locale, e.g. "2 Nov 2026". */
export const formatDate = (iso: string) => new Date(iso).toLocaleDateString(undefined, { dateStyle: "medium" });
